import { create } from "zustand";
import { NetworkLogEntry } from "../types/network.type";

interface NetworkState {
  networkLogs: NetworkLogEntry[];
  addNetworkLog: (entry: NetworkLogEntry) => void;
  clearNetworkLogs: () => void;
}

export const useNetworkStore = create<NetworkState>((set) => ({
  networkLogs: [],
  addNetworkLog: (entry) => set((state) => ({ networkLogs: [entry, ...state.networkLogs] })),
  clearNetworkLogs: () => set({ networkLogs: [] }),
}));
